import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { VNPlayer } from "@/components/VNPlayer";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import Logo from "@/components/Logo";

export default function VNPlay() {
  const { code } = useParams();
  const { user } = useAuth();
  const [scene, setScene] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    document.documentElement.setAttribute("data-zoom-full", "");
    return () => document.documentElement.removeAttribute("data-zoom-full");
  }, []);

  useEffect(() => {
    api.get(`/vn/play/${code}`)
      .then(({ data }) => setScene(data))
      .catch((e) => setErr(e.response?.data?.detail || "This scene link is invalid or was unpublished."));
  }, [code]);

  if (err) {
    return (
      <div className="min-h-screen grid place-items-center bg-[hsl(var(--background))] p-6 text-center" data-testid="vn-play-error">
        <div>
          <p className="text-lg font-semibold mb-3">{err}</p>
          <Link to="/" className="text-[hsl(var(--primary))] font-semibold">Go home</Link>
        </div>
      </div>
    );
  }
  if (!scene) {
    return <div className="min-h-screen grid place-items-center bg-[hsl(var(--background))]"><Loader2 className="w-8 h-8 animate-spin text-[hsl(var(--primary))]" /></div>;
  }

  return (
    <div className="h-screen bg-[hsl(var(--background))] flex flex-col" data-testid="vn-play-page">
      <header className="flex items-center justify-between px-4 py-3 border-b border-[hsl(var(--border))]">
        <Logo to="/" size="sm" />
        <div className="text-center">
          <h1 className="font-display text-base font-extrabold leading-tight" data-testid="vn-play-title">{scene.title}</h1>
          <p className="text-[11px] text-[hsl(var(--muted-foreground))]">by {scene.author_name} · {scene.plays} plays</p>
        </div>
        {user ? (
          <Link to="/app/vn" className="text-xs font-semibold text-[hsl(var(--primary))] inline-flex items-center gap-1"><ArrowLeft className="w-3.5 h-3.5" /> VN Studio</Link>
        ) : (
          <Link to="/register" className="text-xs font-semibold rounded-full bg-[hsl(var(--primary))] text-white px-3 py-1.5">Make your own</Link>
        )}
      </header>
      <main className="flex-1 min-h-0 flex flex-col p-2 sm:p-3 w-full">
        <VNPlayer scene={scene} code={code} canSave={!!user} className="flex-1 min-h-0" />
      </main>
    </div>
  );
}
